import { render, staticRenderFns } from "./xwsj_rj.vue?vue&type=template&id=054c73a1&scoped=true&"
import script from "./xwsj_rj.vue?vue&type=script&lang=js&"
export * from "./xwsj_rj.vue?vue&type=script&lang=js&"
import style0 from "./xwsj_rj.vue?vue&type=style&index=0&id=054c73a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c73a1",
  null
  
)

export default component.exports